import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/articles';

export default function ArticlePreview() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新影视资讯
            </h2>
            <p className="text-foreground-600 text-sm">
              观影指南、版本更新、使用技巧，一手掌握
            </p>
          </div>
          <Link
            to="/article/latest"
            className="whitespace-nowrap text-primary-600 hover:text-primary-700 text-sm font-medium flex items-center gap-1 transition-colors duration-200"
          >
            查看更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <article key={article.id}>
              <Link
                to={`/article/${article.id}`}
                className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 hover:translate-y-[-2px] cursor-pointer"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs bg-primary-100 text-primary-700 px-2.5 py-0.5 rounded-full whitespace-nowrap">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                    {article.title}
                  </h3>
                  <p className="text-foreground-600 text-sm line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="mt-3 flex items-center gap-1 text-primary-600 text-sm font-medium">
                    <span>阅读全文</span>
                    <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform duration-200"></i>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}